<template>
  <div>
    <b-alert
      :variant="alertMessage.variant"
      dismissible
      v-model="alertMessage.show"
    >
      <h5>{{ alertMessage.title }}</h5>
      {{ alertMessage.text }}
    </b-alert>
    <!-- height noch anpassen-->
    <div style="overflow-y: scroll; overflow-x: hidden; max-height: 60vh">
      <div v-if="passedDeliveryNoteComments">
        <div
          v-for="deliveryNoteComment in deliveryNoteComments"
          :key="deliveryNoteComment.id"
        >
          <dn-comment-component
            :deliveryNoteComment="deliveryNoteComment"
            :users="users"
            :user_id="user_id"
          />
        </div>
      </div>
      <div v-else>Keine Kommentare gefunden</div>
    </div>
    <div class="mr-1 mt-5 form-group mb-0 d-flex justify-content-between">
      <textarea
        v-model="commentFormFields.comment"
        size:sm
        class="mb-0"
        row="2"
        style="width: 160px; height: 30px"
      ></textarea>
      <button
        class="button btn p-0"
        @click="createNewDeliveryNoteComment"
        :disabled="commentFormFields.comment.length == 0"
      >
        <i class="bi bi-capslock" style="font-size: 1.25em"></i>
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { duration } from "moment";

export default {
  props: {
    deliveryNoteId: {
      //type: Number,
      required: true,
    },
    passedDeliveryNoteComments: {
      type: [Array],
      default: undefined,
      required: true,
    },
    users: {
      type: [Array],
      required: true,
    },
    user_id: {
      //type: Number,
      required: true,
    },
  },

  data() {
    return {
      deliveryNoteComments: this.passedDeliveryNoteComments,
      commentFormFields: {
        deliveryNoteId: this.deliveryNoteId,
        comment: "",
        userId: this.user_id,
      },
      alertMessage: {
        show: false,
        title: "",
        text: "",
        variant: "",
      },
    };
  },
  methods: {
    showAlert(title, text, variant, disappear) {
      this.alertMessage.show = true;
      this.alertMessage.title = title;
      this.alertMessage.text = text;
      this.alertMessage.variant = variant;

      if (disappear) {
        setTimeout(() => {
          this.alertMessage.show = false;
        }, 1000);
      }
    },
    createNewDeliveryNoteComment() {
      axios
        .post("/deliverynotecomments", this.commentFormFields)
        .then((response) => {
          let postedComment = response.data;
          this.deliveryNoteComments.push(postedComment);
          if (response.status == 200) {
            this.commentFormFields.comment = "";
          }
        })
        .catch((error) => {
          this.showAlert("Fehler", error, "warning", false);
        });
    },
  },
};
</script>
<style>
.button:hover {
  color: #3490dc;
}
.button {
  color: #888888;
}
</style>
